export const NAME = "crowdContentDashboard";

export const IN_QUEUE_TAB = "IN_QUEUE_TAB";
export const DEFAULT_TAB = "DEFAULT_TAB";
export const EDITED_ORDERS_TAB = "EDITED_ORDERS_TAB";
export const RECENTLY_COMPLETED_ORDERS_TAB = "RECENTLY_COMPLETED_ORDERS_TAB";
